import { Currency } from "@bentolabs/kit/entities";
import { formatUnits } from "viem";

import { div, minus, mul } from "shared/utils";
import { scaleDecimals } from "shared/utils/scale-decimals";

export const calculateMinAmount = (amount: string, slippage: string) => {
  const minimumAmount = minus(
    amount,
    div(mul(amount, slippage), 100)
  ).toString();
  return minimumAmount;
};

// uint256 assetPrice = Utils.adjustPrice(oracleRouter.price(address(withdrawAsset)), true);
// uint8 withdrawAssetDecimals = IERC20Metadata(address(withdrawAsset)).decimals();
// assetsOut = Utils.scaleDecimals(shareAmount, 18, withdrawAssetDecimals).mulDivDown(ONE_SHARE, assetPrice);
// if (assetsOut < minimumAssets) revert Teller__MinimumAssetsNotMet();
// vault.exit(to, withdrawAsset, assetsOut, msg.sender, shareAmount);
// emit BulkWithdraw(address(withdrawAsset), shareAmount);
type Params = {
  amount: bigint;
  priceAsset: string;
  currency: Currency;
};
export const previewWithdraw = (params: Params) => {
  const { amount, priceAsset, currency } = params;
  const scaledAmount = scaleDecimals(amount, 18n, BigInt(currency.decimals));
  const val = formatUnits(BigInt(scaledAmount), currency.decimals);
  const assetOut = div(val, priceAsset).toString();
  return assetOut;
};
